import { api } from '@/app/api'
import type { ResourceResponse } from '@/lib/types'
import type {
  CompanyProfile,
  CompanyProfileInput,
  TerminologyResponse,
  TerminologyTerm,
} from './settings-types'

export const settingsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanyProfile: build.query<ResourceResponse<CompanyProfile>, void>({
      query: () => '/v1/companies/me/profile',
      providesTags: ['Company'],
    }),

    updateCompanyProfile: build.mutation<
      ResourceResponse<CompanyProfile>,
      CompanyProfileInput
    >({
      query: (body) => ({ url: '/v1/companies/me/profile', method: 'PATCH', body }),
      invalidatesTags: ['Company', 'Auth'],
    }),

    getTerminology: build.query<TerminologyResponse, void>({
      query: () => '/v1/terminology',
      providesTags: ['Company'],
    }),

    updateTerm: build.mutation<
      { data: TerminologyTerm },
      { termKey: string; singular: string; plural: string }
    >({
      query: ({ termKey, singular, plural }) => ({
        url: `/v1/terminology/${termKey}`,
        method: 'PATCH',
        body: { singular, plural },
      }),
      invalidatesTags: ['Company'],
    }),

    resetTerm: build.mutation<void, string>({
      query: (termKey) => ({ url: `/v1/terminology/${termKey}`, method: 'DELETE' }),
      invalidatesTags: ['Company'],
    }),

    resetAllTerms: build.mutation<void, void>({
      query: () => ({ url: '/v1/terminology/reset', method: 'POST' }),
      invalidatesTags: ['Company'],
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetCompanyProfileQuery,
  useUpdateCompanyProfileMutation,
  useGetTerminologyQuery,
  useUpdateTermMutation,
  useResetTermMutation,
  useResetAllTermsMutation,
} = settingsApi
